/**
 * What: Adapts shared product-language Shopify page copy for the embedded app shell.
 * Transport / data-flow: Pure in-app presentation helpers consuming `@testfeed/product-language`.
 *
 */
import { getShopifyPageLanguage, type ShopifyPageKey } from '@testfeed/product-language'
import type { ShopifyAppViewState } from './resultsNavigation'

/** Every known route has language; an omitted route is a compile error rather than generic Welcome. */
const pageKeys = {
  home: 'home',
  'study-builder': 'study-builder',
  studies: 'studies',
  'study-run': 'study-run',
  'micro-surveys': 'micro-surveys',
  'pixel-events': 'pixel-events',
  insights: 'insights',
  settings: 'settings',
  'settings-integrations': 'integrations',
  support: null,
  'direct-study-results': 'results',
  results: 'results',
} satisfies Record<ShopifyAppViewState['view'], ShopifyPageKey | null>

/** Keeps route labels centralized so navigation and page content do not drift. */
export function pageTitleForView(view: ShopifyAppViewState['view']) {
  const key = pageKeys[view]
  if (key === null) return 'Support'
  return getShopifyPageLanguage(key).navTitle
}

/** Provides the short, reader-facing intro for the active Shopify app view. */
export function introForView(view: ShopifyAppViewState['view']) {
  const key = pageKeys[view]
  if (key === null)
    return {
      title: 'Get TestFeed support',
      body: 'Send TestFeed support the details needed to review your Shopify app question.',
    }
  const language = getShopifyPageLanguage(key)
  return { title: language.title, body: language.body }
}
